import React, { PureComponent, Fragment } from 'react';
import PropTypes, { array } from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container } from 'react-bootstrap'
import { getVoluntaryQn, updateVoluntaryQn, essentialQnUpdated } from '../hooks/question'
import { SnackBar } from '../hooks/Common'
import Questionnaire from "../components/Questionnaire"
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    question: state.question,
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => ({
  getVoluntaryQn: () => dispatch(getVoluntaryQn()),
  updateVoluntaryQn: (data) => dispatch(updateVoluntaryQn(data)),
  essentialQnUpdated: () => dispatch(essentialQnUpdated()),
  SnackBar: (show, message, variant) => dispatch(SnackBar(show, message, variant))
});

const getBarWidth = (total, start) => {
  if (total == null || start == null) {
    return 0
  }
  var bar = 0
  bar = (start / total) * 100 + "%"
  return bar
}

const questionShowHide = (conditions, questions) => {
  var show = true
  if (conditions !== null) {
      show = !conditions.show
      var checkQuestion = questions.find((data) => data.id == conditions.question)
      if (checkQuestion.user_answers === null || checkQuestion.user_answers === "") {
          return false
      }
      if (checkQuestion.type === "radio") {
          var checkAnswer = checkQuestion.answers.find((data) => data.id == checkQuestion.user_answers)
          if (checkAnswer.description.toLowerCase() == conditions.answers[0].toLowerCase()) {
              show = !show
          }
      } else if(checkQuestion.type === "text" || checkQuestion.type === "number") {
          for (let i = 0; i < conditions.answers.length; i++) {
              if (conditions.answers[i] == checkQuestion.user_answers) {
                  show = !show
              }
          }
      } else if(checkQuestion.type === "dropdown") {
        var checkAnswer = checkQuestion.answers.find((data) => data.id == checkQuestion.user_answers)
        if (checkAnswer.description == conditions.answers[0]) {
            show = !show
        }
    }
  }
  return show
}

const getAllQuestions = (questions) => {
  var check = true
  for (let index = 0; index < questions.length; index++) {
    if (!questionShowHide(questions[index].conditions, questions)) { 
      continue  
    }
    if (questions[index].user_answers == null) {
      check = false
    }
  }
  return check
}

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
}

class SelfAssessment extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      start: null,
      question: null,
      total: null,
      shouldNavigate: false,
      path: null
    };
    this.props.getVoluntaryQn()
  }

  componentDidMount = () => {
    if (this.state.start === null && this.props.question.voluntary !== null) {
      this.setState({
        question: this.props.question.voluntary,
        start: 1,
        total: this.props.question.voluntary.length
      })
    }
    if(this.props.auth.user ===null || (this.props.auth.user !==null && this.props.auth.user.voluntary_test)) {
      this.setState({
        shouldNavigate: true,
        path: "/dashboard"
      })
    }
  }

  componentDidUpdate = () => {
    if (this.state.start === null && this.props.question.voluntary !== null) {
      this.setState({
        question: this.props.question.voluntary,
        start: 1,
        total: this.props.question.voluntary.length
      })
    }

    if (this.props.question.questionUpdated == "voluntary") {
      this.props.essentialQnUpdated()
      this.setState({
        shouldNavigate: true,
        path: "/self-assessment-complete"
      })
    }
  }
  handleOptionValue = (parentIndex, childIndex) => {
    var questions = this.state.question[parentIndex].questions
    var id = questions[childIndex].id
    for (let index = 0; index < questions.length; index++) {
      if(questions[index].conditions!==null && questions[index].conditions.question === id) {
          this.setState({
            question: Object.values({
              ...this.state.question,
              [parentIndex]: {
                ...this.state.question[parentIndex],
                questions: Object.values({
                  ...this.state.question[parentIndex].questions,
                  [index]: {
                    ...this.state.question[parentIndex].questions[index],
                    user_answers: null
                  }
                })
              }
            })
          })
      }
    }
  }

  handleAnswerChange = (parentIndex, childIndex, answer) => {
    this.setState({
      question: Object.values({
        ...this.state.question,
        [parentIndex]: {
          ...this.state.question[parentIndex],
          questions: Object.values({
            ...this.state.question[parentIndex].questions,
            [childIndex]: {
              ...this.state.question[parentIndex].questions[childIndex],
              user_answers: answer
            }
          })
        }
      })
    },()=>this.handleOptionValue(parentIndex, childIndex))
    
  }

  handleCheckboxChange = (parentIndex, childIndex, answer) => {
    const { question } = this.state

    const user_answers = question[parentIndex].questions[childIndex].user_answers || []

    const updatedUserAnswers = user_answers.includes(answer)
      ? user_answers.filter((id) => id !== answer)
      : [...user_answers, answer];

    this.setState({
      question: question.map((parent, pIndex) => {
        if (pIndex === parentIndex) {
          return {
            ...parent,
            questions: parent.questions.map((child, cIndex) => {
              if (cIndex === childIndex) {
                return {
                  ...child,
                  user_answers: updatedUserAnswers.length != 0 ? updatedUserAnswers : null,
                }
              }
              return child;
            }),
          };
        }
        return parent;
      })
    },()=>this.handleOptionValue(parentIndex, childIndex))
  }

  handleNext = () => {
    const { question } = this.state
    if (getAllQuestions(question[this.state.start - 1].questions)) {
      if (this.state.start === this.state.total) {
        this.props.updateVoluntaryQn(question)
      } else {
        window.scrollTo({top: 0, behavior: "smooth"})
        this.setState({ start: this.state.start + 1 })
      }
    } else {
      this.props.SnackBar(true, 'Please complete all questions', 'danger')
    }
  }

  handleBack = () => {
    if (this.state.start !== 1) {
      this.setState({ start: this.state.start - 1 })
    }
  }

  render() {
    
    console.log(this.state.question,"questionsquestionsquestionsquestions")
    return <Fragment>
      <NavbarComp access_token={true} />
      <div className="page-sections">
        <div className='self-assessment-wrap'>
          <Container>
            <div className='self-assessment-contents'>
              <div className='self-quest-bar'><span style={{ width: getBarWidth(this.state.total, this.state.start) }}></span></div>
              <h2 className='main-title-style'>SLEEP HEALTH SELF-ASSESSMENT</h2>
              <div className='onboarding-questions-list'>

                {this.state.question !== null ? this.state.question.map((data, parentIndex) => {
                  return <Questionnaire
                    parentIndex={parentIndex}
                    data={data}
                    start={this.state.start}
                    handleAnswerChange={(childIndex, answer) => this.handleAnswerChange(parentIndex, childIndex, answer)}
                    handleCheckboxChange={(childIndex, answer) => this.handleCheckboxChange(parentIndex, childIndex, answer)}
                  />
                }) : null}
                <div className='onboarding-back-next-btns'>
                  {this.state.start === 1 ? <a href={this.props.auth.baseline?'/dashboard':'/alertness'} rel="nofollow"> <button className='back-btn'>Back</button></a> :
                    <button className='back-btn' onClick={this.handleBack}>Back</button>}

                  <button className='next-btn' onClick={this.handleNext}>Next</button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />

    </Fragment>
  }
}

SelfAssessment.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfAssessment);
